// extracted by mini-css-extract-plugin
export default {"main":"GenerationPage_main__Z3ztV","container":"GenerationPage_container__n17uo"};